export default{
  id: null,
  tipoObraId: null,
  tipoObra: [],
  codigoObra: null,
  responsavel: null,
  numeroContrato: null,
  tecnicoReponsavelId: null,
  cliente: null,
  dataVistoria: null,
  funcao: null,
  supervisorId: null,
  fotoPrincipal: null,
  aprAplicacao: null,
  asinnaturarDigital: null,
  status: null,
  assinatura: null,
  contaIDAcao: null,
  coordenador: null,
  dataAcao: null,
  nomeContaAcao: null,
  observacaoApr: null,
  observacao: null,
  statusvistoria: null,
  tecnicoResponsavelId: null,
  atividadeCritica: [],
  ids: [],
  tipoFormat: null,
  ObservacaoReprovado: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/SurveyModel.js